module.exports = __webpack_public_path__ + "assets/img/title.0b52a04c.png";